export default "__VITE_ASSET__BMftgQ64__"